import { Trans } from '@lingui/macro'
import { Button, MenuItem } from '@mui/material'
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'
import { useStartLocalConsultation } from '@/shared/model/useStartLocalConsultation'

type StartLocalConsultationProps = {
  onClose?: () => void
  patientId: string
}

export function StartLocalConsultation({ patientId }: StartLocalConsultationProps) {
  const isLargeScreen = useIsLargeScreen()

  const { startLocalConsultation } = useStartLocalConsultation()

  if (isLargeScreen) {
    return (
      <Button id="start-local" startIcon={<MonitorHeartRoundedIcon />} variant="contained" color="success" onClick={() => startLocalConsultation(patientId)}>
        <Trans>Local Consultation</Trans>
      </Button>
    )
  }

  return (
    <MenuItem
      onClick={() => {
        startLocalConsultation(patientId)
      }}
      disableRipple
    >
      <MonitorHeartRoundedIcon />
      <Trans>Local Consultation</Trans>
    </MenuItem>
  )
}
